import casedetails from "./../src/pages/casedetails/casedetails";
require('./../src/pages/home/item/nav.scss')
// ant css
import 'antd/dist/antd.css'

//公用样式文件
require('./../src/assets/common/css/base.scss')

export default casedetails